import React, {useEffect, useState} from 'react';
import { post } from '../../services/api';
import styles from './SuggestIdeaPage.module.css';
import { useIntl, FormattedMessage } from 'react-intl';
import Title from "../../components/common/Title/Title";
import Button from "../../components/common/Button/Button";
import {usePageLoader} from "../../contexts/PageLoaderContext";
import {useNotifier} from "../../contexts/NotificationContext";
import Textarea from "../../components/common/Textarea/Textarea";
import {showBackButton} from "../../services/telegramService";

const SuggestIdeaPage = () => {
    const intl = useIntl();
    const [description, setDescription] = useState('');

    const { showPageLoader, hidePageLoader } = usePageLoader();
    const { addNotification } = useNotifier();

    useEffect(() => {
        showBackButton();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!description.trim()) {
            addNotification(intl.formatMessage({ id: 'suggestIdeaPage.errorEmpty' }), 'error');
            return;
        }
        showPageLoader();
        try {
            const response = await post('idea', { description }); // POST /idea
            if (response.success) {
                addNotification(response.message || intl.formatMessage({ id: 'suggestIdeaPage.submitSuccess' }), 'success');
            } else {
                throw new Error(response.message || intl.formatMessage({ id: "suggestIdeaPage.submitError" }));
            }
        } catch (err) {
            addNotification(err.message || intl.formatMessage({ id: 'suggestIdeaPage.submitError' }), 'error');
        } finally {
            hidePageLoader();
        }
    };

    return (
        <div className={styles.pageContainer}>
            <Title><FormattedMessage id="suggestIdeaPage.title" /></Title>

            <form onSubmit={handleSubmit} className={styles.ideaForm}>
                <Textarea
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder={intl.formatMessage({ id: "suggestIdeaPage.descriptionPlaceholder" })}
                    rows="8"
                />
                <Button
                    variant="primary"
                    disabled={!description.trim()}
                    type="submit"
                >
                    <FormattedMessage id="suggestIdeaPage.sendButton" />
                </Button>
            </form>
        </div>
    );
};

export default SuggestIdeaPage;
